import { useForm } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Label } from "@/components/ui/label"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogHeader,
  ResponsiveDialogFooter,
  ResponsiveDialogTitle,
  ResponsiveDialogDescription,
  ResponsiveDialogClose,
} from "@/components/ui/responsive-dialog"

// Pick a group and POST it to `postUrl`. Shared by the admin course and
// learning track pages; `subject` ("course" / "track") fills the copy.
export function AssignGroupDialog({
  open,
  onOpenChange,
  postUrl,
  subject,
  availableGroups = [],
}) {
  const form = useForm({ group_id: "" })

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!form.data.group_id) return

    form.post(postUrl, {
      preserveScroll: true,
      onSuccess: () => {
        form.reset()
        onOpenChange(false)
      },
    })
  }

  const handleClose = (isOpen) => {
    if (!isOpen) {
      form.reset()
      form.clearErrors()
    }
    onOpenChange(isOpen)
  }

  return (
    <ResponsiveDialog open={open} onOpenChange={handleClose}>
      <ResponsiveDialogContent className="sm:max-w-md">
        <form onSubmit={handleSubmit}>
          <ResponsiveDialogHeader>
            <ResponsiveDialogTitle className="font-display text-xl">
              Assign Group
            </ResponsiveDialogTitle>
            <ResponsiveDialogDescription>
              Choose a group to assign this {subject} to.
            </ResponsiveDialogDescription>
          </ResponsiveDialogHeader>

          <div className="space-y-4 py-4 px-4 sm:px-0">
            <div className="space-y-2">
              <Label>Group</Label>
              {availableGroups.length > 0 ? (
                <Select
                  value={form.data.group_id}
                  onValueChange={(v) => form.setData("group_id", v)}
                >
                  <SelectTrigger className="bg-white border-zinc-300 text-zinc-900">
                    <SelectValue placeholder="Select a group" />
                  </SelectTrigger>
                  <SelectContent>
                    {availableGroups.map((g) => (
                      <SelectItem key={g.id} value={String(g.id)}>
                        {g.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <p className="text-sm text-zinc-400">
                  All groups are already assigned to this {subject}.
                </p>
              )}
              {form.errors.group_id && (
                <p className="text-sm text-red-600">{form.errors.group_id}</p>
              )}
            </div>
          </div>

          <ResponsiveDialogFooter>
            <ResponsiveDialogClose asChild>
              <Button type="button" variant="outline">
                Cancel
              </Button>
            </ResponsiveDialogClose>
            <Button
              type="submit"
              variant="gradient"
              disabled={form.processing || !form.data.group_id}
            >
              {form.processing ? "Assigning..." : "Assign Group"}
            </Button>
          </ResponsiveDialogFooter>
        </form>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  )
}
